const url = {
    development: process.env.REACT_APP_DEVOZY_API_URL,
    server: process.env.REACT_APP_DEVOZY_API_URL
};

export default url;
